import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  root: css`
    min-width: 32px;
  `,
  skeleton: css`
    display: flex !important;
    vertical-align: -1em;
  `,
}));

export const useAvatarUserStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
